import type { CityConfig } from "../city-template/types";

export const federalWayConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Federal Way",
  state: "Washington",
  stateAbbr: "WA",
  slug: "federal-way",
  route: "/cities/federal-way",
  title: "Emergency Passport Federal Way WA | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Federal Way, Washington — as fast as 24 hours. Fast passport renewal and new passport applications for Federal Way, Auburn, Kent, and all South King County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Federal Way, WA",
  heroSubtitle: "Federal Way travelers — from The Commons shoppers to Hylebos Wetlands nature lovers to South King County families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Federal Way, Auburn, and the South King County corridor.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Federal%20Way%20Washington%20in%20South%20King%20County%20between%20Seattle%20and%20Tacoma%20with%20Dash%20Point%20State%20Park%20and%20Puget%20Sound%20waterfront%2C%20The%20Commons%20mall%20area%2C%20residential%20neighborhoods%20with%20Pacific%20Northwest%20evergreen%20landscape%2C%20Mount%20Rainier%20visible%20in%20the%20distance%20on%20a%20clear%20day%2C%20modern%20suburban%20city%20atmosphere%2C%20warm%20golden%20afternoon%20sunlight%2C%20South%20Puget%20Sound%20region%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=federal-way-hero-001&orientation=landscape",
  heroImageAlt: "Federal Way Washington South King County with Dash Point and Puget Sound",
  geoPosition: "47.3197;-122.3407",
  geoPlacename: "Federal Way, Washington",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "Approximately 22 miles north of Federal Way via I-5",
  },
  nearbyCitiesZips: [
    { name: "Federal Way", zips: "98003, 98023, 98063, 98093" },
    { name: "Auburn", zips: "98001, 98002, 98092, 98071" },
    { name: "Kent", zips: "98030, 98031, 98032, 98035, 98042, 98064, 98089" },
    { name: "Des Moines", zips: "98148, 98158, 98198" },
    { name: "Milton", zips: "98354" },
    { name: "Edgewood", zips: "98371, 98372, 98390" },
    { name: "Fife", zips: "98424" },
    { name: "Pacific", zips: "98047" },
    { name: "Algona", zips: "98001" },
    { name: "Lakeland North", zips: "98001" },
    { name: "Lakeland South", zips: "98003" },
    { name: "Tacoma", zips: "98402, 98403, 98404, 98405, 98406, 98407, 98408, 98409" },
    { name: "Puyallup", zips: "98371, 98372, 98373, 98374, 98375" },
    { name: "Sumner", zips: "98352, 98390" },
    { name: "Bonney Lake", zips: "98391" },
    { name: "Enumclaw", zips: "98022" },
    { name: "Renton", zips: "98055, 98056, 98057, 98058, 98059" },
    { name: "SeaTac", zips: "98148, 98158, 98168, 98188, 98198" },
    { name: "Burien", zips: "98146, 98148, 98166, 98168" },
    { name: "Tukwila", zips: "98108, 98138, 98168, 98178, 98188" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Seattle Passport Agency — just 20 minutes up I-5" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-line", title: "South King County Hub", desc: "Midpoint between Seattle and Tacoma — serving Federal Way, Auburn, Kent, and Des Moines" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any South King County location" },
  ],
  internalLinks: [
    { name: "Expedited passport in Seattle, WA", route: "/cities/seattle" },
    { name: "Urgent passport services in Tacoma, WA", route: "/cities/tacoma" },
    { name: "Emergency passport help in Renton, WA", route: "/cities/renton" },
    { name: "Washington passport services overview", route: "/states/washington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Federal Way, Washington remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — approximately 20 minutes north via I-5. Federal Way residents can ship from any UPS or FedEx in South King County.",
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeDistance: "Serving Federal Way, Auburn, Kent, Des Moines, Milton, Edgewood, Fife, Pacific, Algona, and all of South King County and north Pierce County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Federal Way and South King County. From The Commons at Federal Way to the Hylebos Wetlands, from Dash Point State Park on the Puget Sound to the suburban neighborhoods along Pacific Highway South — we serve all of Federal Way and the communities between Seattle and Tacoma.",
  nearbyCitiesIntro: "We serve Federal Way and all nearby communities including Auburn, Kent, Des Moines, Milton, Edgewood, Fife, Pacific, and Algona. We also serve Tacoma, Puyallup, and north Pierce County. Our service covers the entire I-5 corridor between Seattle and Tacoma.",
  howItWorksIntro: "Most Federal Way travelers complete everything online and ship documents overnight. No need to drive 20 minutes north on I-5 to Seattle — our couriers handle the agency delivery and always pick the fastest route.",
  mistakesIntro: "Federal Way is a major South King County hub between Seattle and Tacoma on the I-5 corridor. Here are the most common passport mistakes we see from Federal Way-area travelers.",
  testimonialsIntro: "Federal Way travelers — from suburban families to business commuters to South King County residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Federal Way, WA? Here are the most common ones we hear from South King County travelers.",
  statePageRoute: "/states/washington",
  statePageName: "Washington",
  dmvWebsite: "https://www.dol.wa.gov",
  dmvLabel: "Washington DOL — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close I-5 corridor proximity", "No I-5 traffic or downtown parking hassle", "Perfect for South King County travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Seattle Passport Agency — close I-5 corridor proximity", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to downtown Seattle on I-5", "Parking and traffic in downtown Seattle"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Federal Way travelers with immediate departure needs — as fast as 24 hours. Our couriers use the Seattle Passport Agency. Perfect for South King County family vacations, business travel, and last-minute trips.",
      bullets: ["24–48 hour turnaround available", "Seattle Passport Agency — I-5 corridor courier", "South King County family and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Federal Way adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your South King County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Federal Way residents and families — including suburban families, military families, and South King County residents.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Federal Way residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Federal Way and South King County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Federal Way and South King County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Federal Way WA", description: "Urgent passport processing for Federal Way Washington travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Federal Way WA", description: "Fast passport renewal for Federal Way Washington residents with a previously-issued passport." },
    { name: "First-Time Passport Federal Way WA", description: "New passport application services for Federal Way Washington residents applying for their first passport." },
    { name: "Child Passport Federal Way WA", description: "Minor passport services for Federal Way Washington families with children under 16." },
  ],
  testimonials: [
    {
      name: "David C.",
      location: "Federal Way, WA",
      rating: 5,
      text: "Family trip to Cancun with 7 days notice. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store near The Commons. Outstanding service for South King County families.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Sarah & Tom B.",
      location: "Auburn, WA",
      rating: 5,
      text: "Trip to Paris with 10 days notice. Two passports — one adult renewal and one first-time for my husband. Done in 4 days. We shipped from FedEx on Pacific Highway. Incredible turnaround.",
      service: "Couple's Passport Bundle",
    },
    {
      name: "Rachel L.",
      location: "Des Moines, WA",
      rating: 5,
      text: "Business trip to Seoul with 8 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. The I-5 corridor courier service is a game changer for South King County.",
      service: "Emergency Passport",
    },
    {
      name: "Marcus J.",
      location: "Edgewood, WA",
      rating: 5,
      text: "Lost my passport before a work trip to Toronto. Fast Passport Center replaced it in 48 hours. Not having to navigate Seattle traffic was worth every penny.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "fwy-1",
      name: "Federal Way Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "32925 1st Ave S",
      city: "Federal Way",
      state: "WA",
      zip: "98003",
      phone: "(253) 838-4812",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Federal Way, near The Commons mall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Federal Way acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to The Commons, Dash Point, and central Federal Way neighborhoods.",
      icon: "ri-mail-line",
    },
    {
      id: "fwy-2",
      name: "Auburn Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11 3rd St NW",
      city: "Auburn",
      state: "WA",
      zip: "98001",
      phone: "(253) 939-8658",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Auburn, approximately 5 miles south of Federal Way",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Auburn, Algona, and Pacific. Good alternative for south Federal Way and east Auburn residents.",
      icon: "ri-mail-line",
    },
    {
      id: "fwy-3",
      name: "Kent Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10612 SE 240th St",
      city: "Kent",
      state: "WA",
      zip: "98031",
      phone: "(253) 852-3301",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Kent, approximately 7 miles east of Federal Way",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Kent, Covington, and south King County. Good alternative for east Federal Way residents.",
      icon: "ri-mail-line",
    },
    {
      id: "fwy-4",
      name: "Des Moines Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "21935 Marine View Dr S",
      city: "Des Moines",
      state: "WA",
      zip: "98198",
      phone: "(206) 824-4106",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Des Moines, approximately 5 miles northwest of Federal Way",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Des Moines, west Federal Way, and waterfront communities. Good alternative for west county residents.",
      icon: "ri-mail-line",
    },
    {
      id: "fwy-5",
      name: "King County Clerk — Seattle",
      type: "County Clerk Passport Acceptance",
      address: "516 3rd Ave, Room W-105",
      city: "Seattle",
      state: "WA",
      zip: "98104",
      phone: "(206) 477-3080",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Seattle Courthouse — approximately 20 minutes north via I-5",
      website: "https://www.kingcounty.com/depts/courts/clerk.aspx",
      websiteLabel: "King County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to post office. Federal Way residents may prefer the Federal Way or Auburn post offices for convenience.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — I-5 traffic to downtown Seattle", fpc: "No — ship from Federal Way" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "South King County Advantage", agency: "No special guidance", fpc: "Yes — Federal Way and suburban travel expertise" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Federal Way suburban families often discover passport issues just before summer vacations. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services at The Commons or on Pacific Highway South sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at King County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Federal Way and Auburn Post Office appointments fill during summer travel and the holiday shopping season at The Commons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating I-5 Corridor Traffic",
      description: "Federal Way sits directly on I-5 between Seattle and Tacoma — this is one of the busiest freeway segments in Washington. Rush hour can turn a 20-minute trip to Seattle into an hour. Never attempt a last-minute drive to the Seattle passport agency — use our courier service instead.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Summer family vacations and international business travel are year-round in South King County — plan ahead.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Federal Way area or South King County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Federal Way, Auburn, or Kent." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Seattle Passport Agency — no need to battle I-5 traffic yourself." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Federal Way address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Federal Way, WA?", a: "Fast Passport Center offers emergency passport processing in Federal Way, Washington in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Seattle Passport Agency (915 2nd Ave Suite 500, Seattle WA 98174) — approximately 20 minutes north via I-5." },
    { q: "Does Federal Way have its own passport agency?", a: "No — Federal Way does not have a regional passport agency. The nearest facility is the Seattle Passport Agency (approximately 20 minutes north via I-5). Fast Passport Center's courier service means Federal Way residents never need to deal with I-5 corridor traffic and downtown Seattle parking." },
    { q: "Can I get an expedited passport in Auburn, Kent, or Des Moines?", a: "Absolutely. Fast Passport Center serves all of South King County including Auburn, Kent, Des Moines, Milton, Edgewood, Fife, and Pacific. Our service works the same way everywhere in the region." },
    { q: "What airport do Federal Way travelers use for international flights?", a: "Seattle-Tacoma International Airport (SEA) is the primary airport — just 15 minutes from Federal Way via I-5. SEA is actually closer to Federal Way than it is to downtown Seattle. SEA offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Always verify passport validity for at least 6 months past your return date." },
    { q: "Is Federal Way closer to SEA Airport than Seattle is?", a: "Yes — Federal Way is actually closer to Seattle-Tacoma International Airport (approximately 15 minutes via I-5) than downtown Seattle is (approximately 20 minutes). This makes Federal Way one of the most airport-convenient suburbs in Washington for international travelers." },
    { q: "How much does an expedited passport cost in Federal Way, WA?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Federal Way?", a: "Walgreens, CVS, and Rite Aid stores throughout Federal Way offer passport photos. UPS Store and FedEx Office locations at The Commons and along Pacific Highway South also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the Tacoma Dome area from Federal Way?", a: "Yes. Fast Passport Center serves all of South King County and north Pierce County including the Tacoma Dome area, Puyallup, and the surrounding communities. Federal Way and Tacoma are just 10 minutes apart via I-5." },
  ],
  photoLocations: [
    { name: "Walgreens — Pacific Highway", address: "34200 Pacific Hwy S, Federal Way, WA 98003", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "Rite Aid — The Commons", address: "1900 S 320th St, Federal Way, WA 98003", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/locations" },
    { name: "UPS Store — Federal Way", address: "33720 9th Ave S, Federal Way, WA 98003", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/tools/find-a-store" },
    { name: "FedEx Office — Kent", address: "1816 S 320th St, Federal Way, WA 98003", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/location.html" },
  ],
  dmvLocations: [
    { name: "WA DOL — Federal Way", address: "1617 S 324th Pl, Federal Way, WA 98003", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Washington Department of Licensing for driver's licenses, REAL ID, and vehicle registration. Online appointments strongly recommended.", featured: true },
    { name: "WA DOL — Auburn", address: "1525 A St NE, Auburn, WA 98002", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Serves Auburn and south King County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "15 minutes from Federal Way via I-5",
      address: "17801 International Blvd, Seattle, WA 98158",
      note: "Primary airport for Federal Way — closer to Federal Way than to downtown Seattle. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. Alaska Airlines and Delta Air Lines hub. Federal Way is one of the most airport-convenient suburbs in Washington.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Flight Info",
      featured: true,
    },
    {
      code: "BFI",
      name: "King County International Airport (Boeing Field)",
      distance: "Approximately 20 minutes north via I-5",
      address: "7277 Perimeter Rd S, Seattle, WA 98108",
      note: "General aviation and cargo airport. Not typically used for international passenger travel. Serves Boeing and corporate aviation.",
      flightUrl: "https://www.kingcounty.gov/depts/transportation/kcia.aspx",
      flightLabel: "BFI Info",
      featured: false,
    },
  ],
};